<template>
  <div
    class="wallet-view"
    :style="shellStyle"
  >
    <wallet-header v-if="isAuthenticatedRoute" />

    <v-container v-if="isAuthenticatedRoute">
      <complete-signup-form v-if="!isSignupComplete" />
      <router-view />
    </v-container>

    <router-view v-else />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import {
  GET_IS_AUTHENTICATED,
  GET_IS_SIGNUP_COMPLETE,
  GET_REWARD_ELEMENT_CUSTOMIZATION_BY_SELECTOR
} from '@/store/get-types'
import CompleteSignupForm from '@/components/wallet/CompleteSignupForm'
import { ALLOW_UNAUTHENTICATED_META_PROP } from '@/router/routes/wallet-routes'
import WalletHeader from '@/components/wallet/WalletHeader'

const SVP_BODY_SELECTOR = '#svp-body'

export default {
  name: 'WalletView',
  components: { WalletHeader, CompleteSignupForm },
  computed: {
    ...mapGetters({
      isAuthenticated: GET_IS_AUTHENTICATED,
      isSignupComplete: GET_IS_SIGNUP_COMPLETE,
      getElementCustomizationBySelector: GET_REWARD_ELEMENT_CUSTOMIZATION_BY_SELECTOR
    }),
    isAuthenticatedRoute () {
      const { meta } = this.$route || {}
      const { [ALLOW_UNAUTHENTICATED_META_PROP]: allowUnauthenticated } =
        meta || {}
      return !allowUnauthenticated && this.isAuthenticated
    },
    shellStyle () {
      const { css: shellStyle } =
        this.getElementCustomizationBySelector(SVP_BODY_SELECTOR) || {}
      return shellStyle
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'src/assets/css/variables';
.wallet-view {
  min-height: 100vh;
  background: $tangoLtGray;
}
</style>
